/*
 * @Description: 订单超额列表
 * @Date: 2021-01-13 15:08:22
 */
import fields from './fields';
import TableRenderClass from '@/components/tableRender/tableRenderClass';

const example = new TableRenderClass({ fields });

const part = example.createPart({
  name: '订单提示',
  list: null,
  fields: [
    'index',
    'fullName',
    'userPhone',
    'taxCollectionPattern',
    // 'quotaPrice',
    'csoCustomOrderNo',
    'projectName',
    'projectPrice',
    'payStatus',
    'totalprojectPrice',
    'handler'
  ]
});

const conflictPart = example.createPart({
  name: '订单提示',
  list: null,
  fields: [
    'index',
    {
      label: '姓名',
      prop: 'userName'
    },
    {
      label: '手机号',
      prop: 'phone'
    },
    'taxCollectionPattern',
    // 'quotaPrice',
    'orderNo'
  ]
});
/*主页面入口*/
export default [{ name: '订单提示', childMenu: [part] }];

export const conflict = [{ name: '订单提示', childMenu: [conflictPart] }];
